<template>
    <div class="allRank-view" ref="rankListWrapper">
        <div>
            <div class="allRank-view-body">
                <div class="types-mask">
                    <h5>
                        {{ langTransfer('全部榜单') }}
                    </h5>
                    <div class="types-list">
                        <p v-for="(item,index) in types"
                           :key="index"
                           :style="{color: index === checkedTypeIndex ? themeColor : ''}"
                           @click="changeType(index)">
                            {{ langTransfer(item.text) }}
                        </p>
                    </div>
                </div>
                <div class="rank-list-mask">
                    <div class="rank-list-header">
                        <h5>
                            <i :style="{background: themeColor}" class="warning-icon"/>
                            {{ types ? langTransfer(types[checkedTypeIndex].text) : '' }}
                        </h5>
                        <div v-show="checkedTypeIndex === 0 || checkedTypeIndex === 1"
                             class="selected-btn"
                             @click="showSelectOptions = !showSelectOptions">
                            <p>{{ langTransfer(selectOptions[checkedSelectOptionIndex].text) }}</p>
                            <div :style="{transform: showSelectOptions? 'rotate(180deg)':''}"
                                 class="select-icon"/>
                        </div>
                        <div :class="{ 'select-option-showed': showSelectOptions }"
                             class="select-option-mask">
                            <div class="select-option">
                                <p v-for="(item,index) in selectOptions"
                                   :key="index"
                                   @click="checkSelect(index)">
                                    {{ langTransfer(item.text) }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="rank-list-wrapper">
                        <div :class="rankListClassName" class="rank-list-body">
                            <div class="list-body-mask">
                                <template v-if="resourceType === 'audio' || resourceType === 'video'">
                                    <div v-for="(item,index) in resourceListData"
                                         :key="index"
                                         class="rank-item"
                                         @click="goDetail(item)">
                                        <b>{{ index + 1 }}</b>
                                        <img :src="item.__cover">
                                        <div class="rank-item-infos">
                                            <h5>{{ item.Name }}</h5>
                                            <p>{{ item.Intro }}</p>
                                            <i></i>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div v-for="(item,index) in resourceListData"
                                         :key="index"
                                         class="rank-item"
                                         @click="goDetail(item)">
                                        <img :src="item.__cover">
                                        <div class="rank-item-infos">
                                            <h5>{{ item.Name }}</h5>
                                            <span>{{ item.__midInfo }}</span>
                                            <p v-html="item.__bottomInfo"></p>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <!-- <div class="site-footer">
                                <Footer/>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="site-footer">
                 <Footer/>
            </div>
        </div>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import Footer from '@/components/footer'
    export default {
        components: {
            Footer
        },
        data () {
            return {
                allRankBScroll: null,
                allTypes: {
                    magazine: [
                        {
                            text: '阅读排行',
                            typeVal: 'read'
                        },
                        {
                            text: '借阅排行',
                            typeVal: 'download'
                        },
                        {
                            text: '最新上架',
                            typeVal: 'latest'
                        }
                    ],
                    book: [
                        {
                            text: '阅读排行',
                            typeVal: 'read'
                        },
                        {
                            text: '借阅排行',
                            typeVal: 'download'
                        },
                        {
                            text: '最新上架',
                            typeVal: 'latest'
                        }
                    ],
                    audio: [
                        {
                            text: '人气排行',
                            typeVal: 'read'
                        },
                        {
                            text: '下载排行',
                            typeVal: 'download'
                        },
                        {
                            text: '最新上架',
                            typeVal: 'latest'
                        }
                    ],
                    video: [
                        {
                            text: '人气排行',
                            typeVal: 'read'
                        },
                        {
                            text: '下载排行',
                            typeVal: 'download'
                        },
                        {
                            text: '最新上架',
                            typeVal: 'latest'
                        }
                    ],
                    newspaper: [
                        {
                            text: '人气排行',
                            typeVal: 'read'
                        },
                        {
                            text: '下载排行',
                            typeVal: 'download'
                        },
                        {
                            text: '最新上架',
                            typeVal: 'latest'
                        }
                    ]
                },
                checkedTypeIndex: 0,
                selectOptions: [
                    {
                        text: '全部',
                        val: {
                            read: 1,
                            download: 4
                        }
                    },
                    {
                        text: '最近一周',
                        val: {
                            read: 3,
                            download: 6
                        }
                    },
                    {
                        text: '最近一个月',
                        val: {
                            read: 2,
                            download: 5
                        }
                    }
                ],
                checkedSelectOptionIndex: 0,
                showSelectOptions: false,
                resourceType: '',
                resourceListData: [],
                hasAllData: false,
                lastParams: {}
            }
        },
        computed: {
            types () {
                const { resourceType } = this
                return this.allTypes[resourceType]
            },
            rankListClassName () {
                const { resourceType } = this
                return {
                    'audio-likely': resourceType === 'audio',
                    'book-likely': resourceType === 'book',
                    'magazine-likely': resourceType === 'magazine',
                    'newspaper-likely': resourceType === 'newspaper',
                    'video-likely': resourceType === 'video'
                }
            },
            themeColor () {
                return this.$store.state.themeColor
            }
        },
        activated () {
        },
        mounted () {
            this.initBScroll()
        },
        methods: {
            initBScroll () {
                this.$nextTick(() => {
                    this.allRankBScroll = new BScroll(this.$refs.rankListWrapper, {
                        bounce: false,
                        click: true,
                        pullUpLoad: {
                            threshold: 300
                        },
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 300
                        }
                    })
                    this.allRankBScroll.on('pullingUp', () => {
                        try {
                            if (!this.hasAllData) {
                                this.getListData()
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    })
                })
            },
            changeType (index) {
                if (this.checkedTypeIndex === index) {
                    return
                }
                const { resourceType } = this.$route.params
                this.$router.push({
                    name: 'allRank',
                    params: {
                        resourceType,
                        typeIndex: index
                    }
                })
            },
            checkSelect (index) {
                if (this.checkedSelectOptionIndex === index) {
                    return
                }
                this.checkedSelectOptionIndex = index
                this.showSelectOptions = false
                this.hasAllData = false
                this.resourceListData = []
                this.getListData()
            },
            getListData () {
                const {
                    resourceType, checkedTypeIndex, selectOptions, checkedSelectOptionIndex, allTypes
                } = this
                const { typeVal } = allTypes[resourceType][checkedTypeIndex]
                const kind = selectOptions[checkedSelectOptionIndex].val[typeVal]
                if (typeVal === 'latest') {
                    this.getLatestList()
                } else {
                    this.getRankList(kind)
                }
            },
            goDetail (item) {
                const { resourceType } = this
                this.$tools.goDetailRoute.call(this, resourceType, item)
            },
            async getRankList (kind, top = 10) {
                try {
                    const {
                        resourceType, resourceListData
                    } = this
                    if (resourceListData.length % 10 !== 0) {
                        return
                    }
                    if (resourceListData.length > 0) {
                        top = resourceListData.length + 10
                    }
                    let { Data } = await this.$apis(resourceType)
                        .getRankList(kind, top)
                    const toolFnName = `format${ this.$tools.forMatFirstWord(resourceType) }Data`
                    Data = this.$tools[toolFnName](Data)
                    if (resourceListData && resourceListData.length > 0) {
                        this.allRankBScroll.finishPullUp()
                    }
                    this.resourceListData = Data
                    if (top > Data.length) {
                        this.hasAllData = true
                        return
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async getLatestList (top = 10) {
                try {
                    const {
                        resourceType, resourceListData
                    } = this
                    if (resourceListData.length % 10 !== 0) {
                        return
                    }
                    if (resourceListData.length > 0) {
                        top = resourceListData.length + 10
                    }
                    if (top >= 100) {
                        return
                    }
                    let { Data } = await this.$apis(resourceType)
                        .getLatestList(top)
                    const toolFnName = `format${ this.$tools.forMatFirstWord(resourceType) }Data`
                    Data = this.$tools[toolFnName](Data)
                    if (resourceListData && resourceListData.length > 0) {
                        this.allRankBScroll.finishPullUp()
                    }
                    this.resourceListData = Data
                    if (top > Data.length) {
                        this.hasAllData = true
                        return
                    }
                } catch (error) {
                    console.log(error)
                }
            }
        },
        beforeRouteUpdate (to, from, next) {
            const { resourceType, typeIndex } = to.params
            this.checkedTypeIndex = Number(typeIndex)
            this.resourceType = resourceType
            this.hasAllData = false
            this.resourceListData = []
            this.getListData()
            next()
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                const { params } = vm.$route
                if (vm.$tools.isSameParams(params, vm.lastParams)) {
                    return
                }
                vm.lastParams = params
                const { resourceType, typeIndex } = params
                vm.checkedTypeIndex = Number(typeIndex)
                vm.resourceType = resourceType
                vm.hasAllData = false
                vm.resourceListData = []
                vm.getListData()
            })
        }
    }
</script>

<style lang="scss" scoped>
    .allRank-view {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
    }

    .allRank-view-body {
        width: 1140px;
        height: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        padding-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        position: relative;
    }

    .types-mask {
        width: 270px;
        height: 186px;
        margin-right: 20px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;

        h5 {
            width: 100%;
            height: 50px;
            padding: 0 16px;
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
            border-bottom: 1px solid #F0F2F7;
        }

        .types-list {
            padding: 8px 0;

            p {
                width: 100%;
                box-sizing: border-box;
                padding: 0 16px;
                
                font-size: 14px;
                color: #1A1A1A;
                line-height: 40px;
                cursor: pointer;
            }

            p:hover {
                background: #F6F6F6;
            }
        }
    }

    .rank-list-mask {
        // position: absolute;
        top: 20px;
        bottom: 20px;
        left: 290px;
        right: 0;
        background: #fff;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
    }

    .rank-list-header {
        width: 850px;
        height: 50px;
        box-sizing: border-box;
        padding: 0 34px 0 16px;
        background: #fff;
        border-bottom: 1px solid #F0F2F7;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        h5 {
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
            position: relative;
            padding-left: 12px;
        }

        .warning-icon {
            display: block;
            width: 4px;
            height: 16px;
            background: #0084FF;
            border-radius: 2px;
            position: absolute;
            left: 0;
            top: 17px;
        }


        .selected-btn {
            width: 100px;
            height: 32px;
            box-sizing: border-box;
            padding: 0 5px;
            background: #FFFFFF;
            border: 1px solid #DCDFE6;
            border-radius: 4px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            position: relative;
            cursor: pointer;

            p {
                
                font-size: 13px;
                color: #606266;
                letter-spacing: 0;
                line-height: 14px;
                width: 72px;
                text-align: center;
            }

            .select-icon {
                width: 0;
                height: 0;
                border-left: 4px solid transparent;
                border-right: 4px solid transparent;
                border-top: 5px solid #909399;
                transition: transform 0.2s;
            }
        }

        .select-option-mask {
            position: absolute;
            right: 34px;
            top: 57px;
            z-index: 2;
            background: #FFFFFF;
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.12), 0 0 6px 0 rgba(0,0,0,0.04);
            overflow: hidden;
            max-height: 0;
            border: none;
            transition: max-height .1s ease-in;
        }

        .select-option {
            width: 150px;
            padding: 8px 0;
            border: 1px solid #D6DCE2;
            border-radius: 2px;

            p {
                font-size: 14px;
                color: #475669;
                letter-spacing: 0;
                line-height: 14px;
                height: 36px;
                line-height: 36px;
                padding-left: 10px;
                cursor: pointer;
            }

            p:hover {
                background: #F6F6F6;
            }
        }

        .select-option-showed {
            max-height: 160px;
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.12), 0 0 6px 0 rgba(0,0,0,0.04);
        }
    }

    .site-footer {
        // position: absolute;
        bottom: 0;
        left: 0;
    }

    .rank-list-wrapper {
        // overflow: hidden;
        //position: absolute;
        top: 50px;
        bottom: 0;
        left: 0;
        right: 0;
        width: 850px;
    }

    .magazine-likely.rank-list-body, .book-likely.rank-list-body, .newspaper-likely.rank-list-body {
        min-height: 100%;
        box-sizing: border-box;
        padding: 32px 34px 34px;

        .list-body-mask {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
        }

        .rank-item {
            width: 374px;
            height: 190px;
            margin-bottom: 32px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;

            img {
                width: 150px;
                height: 190px;
                border-radius: 4px;
                cursor: pointer;
            }
        }

        .rank-item-infos {
            width: 208px;
            height: 190px;
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 22px;
            position: relative;

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 22px;
                cursor: pointer;
            }

            span {
                display: block;
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                margin: 8px 0 16px;
                cursor: pointer;
            }

            p {
                
                font-size: 14px;
                color: #79808B;
                letter-spacing: 0;
                text-align: justify;
                line-height: 20px;
                max-height: 60px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                cursor: pointer;
                position: absolute;
                bottom: 0;
                left: 0;
            }

            i {
                display: block;
                font-style: normal;
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                cursor: pointer;
            }
        }
    }

    .audio-likely.rank-list-body,.video-likely.rank-list-body {
        min-height: 100%;
        box-sizing: border-box;
        padding: 8px 24px 24px;

        .list-body-mask {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
        }

        .rank-item {
            width: 100%;
            height: 119px;
            border-bottom: 1px solid #F0F2F7;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            b {
                display: block;
                width: 30px;
                height: 30px;
                box-sizing: border-box;
                padding-left: 9px;
                
                font-size: 18px;
                color: #8590A6;
                line-height: 30px;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
            }

            img {
                display: block;
                width: 80px;
                height: 80px;
                border-radius: 4px;
                cursor: pointer;
                margin: 0 24px 0 16px;
            }
        }

        .rank-item:nth-child(1) {
            b {
                color: #fff;
                background-image: url("../../assets/homeRecommend/rankOne.png");
            }
        }

        .rank-item:nth-child(2) {
            b {
                color: #fff;
                background-image: url("../../assets/homeRecommend/rankTwo.png");
            }
        }

        .rank-item:nth-child(3) {
            b {
                color: #fff;
                background-image: url("../../assets/homeRecommend/rankThree.png");
            }
        }

        .rank-item:last-child {
            border-bottom: none;
        }

        .rank-item-infos {
            width: 652px;
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 22px;

            h5 {
                
                font-size: 18px;
                color: #1A1A1A;
                line-height: 18px;
                margin-top: 4px;
                cursor: pointer;
            }

            p {
                
                font-size: 16px;
                color: #79808B;
                line-height: 16px;
                height: 16px;
                margin: 8px 0 16px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
            }

            i {
                display: block;
                font-style: normal;
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                cursor: pointer;
            }
        }
    }
</style>
